import { render } from "./ProfileVisits.vue?vue&type=template&id=2eef864c"
import script from "./ProfileVisits.vue?vue&type=script&lang=js"
export * from "./ProfileVisits.vue?vue&type=script&lang=js"
script.render = render

export default script